function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "LINE-LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,160c0,88.365 -71.635,160 -160,160c-88.365,0 -160,-71.635 -160,-160c0,-88.365 71.635,-160 160,-160c88.365,0 160,71.635 160,160",
    style: {
      fill: "#4cc764",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.705,150.681c0,-47.795 -47.916,-86.681 -106.814,-86.681c-58.893,-0 -106.814,38.886 -106.814,86.681c0,42.85 38,78.734 89.331,85.519c3.478,0.752 8.213,2.294 9.41,5.267c1.076,2.699 0.704,6.931 0.346,9.658c0,-0 -1.254,7.537 -1.525,9.144c-0.466,2.699 -2.147,10.561 9.252,5.759c11.401,-4.804 61.513,-36.222 83.922,-62.014l-0.004,-0c15.479,-16.977 22.896,-34.204 22.896,-53.333",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.171,178.279c1.126,0 2.039,-0.913 2.039,-2.039l-0,-7.575c-0,-1.121 -0.918,-2.039 -2.039,-2.039l-20.395,0l-0,-7.867l20.395,0c1.126,0 2.039,-0.914 2.039,-2.04l-0,-7.575c-0,-1.121 -0.918,-2.039 -2.039,-2.039l-20.395,0l-0,-7.866l20.395,0c1.126,0 2.039,-0.914 2.039,-2.04l-0,-7.575c-0,-1.121 -0.918,-2.039 -2.039,-2.039l-30.01,0c-1.126,0 -2.039,0.913 -2.039,2.039l-0,46.616c-0,1.126 0.913,2.039 2.039,2.039l30.01,0Z",
    style: {
      fill: "#4cc764",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.166,178.279c1.127,0 2.04,-0.913 2.04,-2.039l0,-7.575c0,-1.121 -0.918,-2.039 -2.04,-2.039l-20.395,0l0,-37.002c0,-1.121 -0.917,-2.039 -2.039,-2.039l-7.575,0c-1.127,0 -2.039,0.913 -2.039,2.039l0,46.616c0,1.126 0.912,2.039 2.039,2.039l30.009,0Z",
    style: {
      fill: "#4cc764",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.232,127.585l-7.575,-0c-1.126,-0 -2.039,0.913 -2.039,2.039l-0,46.616c-0,1.126 0.913,2.039 2.039,2.039l7.575,0c1.127,0 2.04,-0.913 2.04,-2.039l-0,-46.616c-0,-1.126 -0.913,-2.039 -2.04,-2.039",
    style: {
      fill: "#4cc764",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.801,127.585l-7.575,-0c-1.126,-0 -2.039,0.913 -2.039,2.039l-0,27.688l-21.328,-28.803c-0.05,-0.074 -0.106,-0.145 -0.164,-0.211c-0.004,-0.005 -0.009,-0.01 -0.014,-0.015c-0.039,-0.044 -0.08,-0.087 -0.122,-0.128c-0.013,-0.011 -0.027,-0.022 -0.039,-0.034c-0.036,-0.032 -0.073,-0.063 -0.111,-0.094c-0.018,-0.013 -0.036,-0.027 -0.055,-0.041c-0.034,-0.025 -0.071,-0.05 -0.108,-0.074c-0.02,-0.014 -0.041,-0.025 -0.062,-0.038c-0.037,-0.021 -0.074,-0.043 -0.112,-0.061c-0.022,-0.012 -0.043,-0.022 -0.066,-0.033c-0.039,-0.017 -0.078,-0.035 -0.119,-0.05c-0.022,-0.009 -0.044,-0.017 -0.066,-0.025c-0.041,-0.015 -0.082,-0.027 -0.124,-0.04c-0.024,-0.007 -0.048,-0.013 -0.072,-0.018c-0.041,-0.01 -0.081,-0.019 -0.122,-0.027c-0.028,-0.005 -0.057,-0.009 -0.086,-0.013c-0.037,-0.005 -0.073,-0.01 -0.11,-0.013c-0.036,-0.003 -0.072,-0.005 -0.11,-0.006c-0.022,0 -0.045,-0.003 -0.069,-0.003l-7.533,0c-1.127,0 -2.04,0.913 -2.04,2.039l-0,46.616c-0,1.126 0.913,2.039 2.04,2.039l7.575,0c1.126,0 2.039,-0.913 2.039,-2.039l-0,-27.678l21.355,28.838c0.147,0.208 0.327,0.379 0.526,0.514c0.008,0.006 0.016,0.012 0.023,0.017c0.042,0.027 0.085,0.053 0.128,0.078c0.02,0.011 0.039,0.021 0.06,0.032c0.032,0.017 0.065,0.033 0.099,0.048c0.033,0.015 0.066,0.029 0.1,0.043c0.022,0.009 0.043,0.016 0.065,0.023c0.046,0.017 0.092,0.033 0.14,0.045c0.01,0.003 0.02,0.006 0.03,0.008c0.17,0.045 0.348,0.071 0.533,0.071l7.533,-0c1.126,-0 2.039,-0.913 2.039,-2.039l-0,-46.616c-0,-1.126 -0.913,-2.039 -2.039,-2.039",
    style: {
      fill: "#4cc764",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLogo);
export default __webpack_public_path__ + "static/media/line_logo.7a22e04fc53e64cf08b25d4330bd9c85.svg";
export { ForwardRef as ReactComponent };